import { lazy, Suspense, useEffect, type ReactNode } from 'react';
import { ThemeProvider } from './components/ThemeProvider';
import { MainLayout } from './layouts/MainLayout';
import { Home } from './pages/Home';
import { OrganicLanding } from './pages/OrganicLanding';
import { organicPages } from './pages/organicContent';
import { initGA, trackPageView } from './services/analytics';
import { CookieConsent } from './components/CookieConsent';

const About = lazy(() => import('./pages/About').then((module) => ({ default: module.About })));
const Contact = lazy(() => import('./pages/Contact').then((module) => ({ default: module.Contact })));
const Cookies = lazy(() => import('./pages/Cookies').then((module) => ({ default: module.Cookies })));
const NotFound = lazy(() => import('./pages/NotFound').then((module) => ({ default: module.NotFound })));
const Pricing = lazy(() => import('./pages/Pricing').then((module) => ({ default: module.Pricing })));
const Privacy = lazy(() => import('./pages/Privacy').then((module) => ({ default: module.Privacy })));
const Terms = lazy(() => import('./pages/Terms').then((module) => ({ default: module.Terms })));

const deferredPage = (page: ReactNode) => <MainLayout showAnnouncement={false}><Suspense fallback={null}>{page}</Suspense></MainLayout>;

const routeContent = () => {
    switch (window.location.pathname) {
        case '/': return <MainLayout><Home /></MainLayout>;
        case '/about': return deferredPage(<About />);
        case '/pricing': return deferredPage(<Pricing />);
        case '/contact': return deferredPage(<Contact />);
        case '/ai-nutrition-coach': return <MainLayout showAnnouncement={false}><OrganicLanding content={organicPages.nova} page="nova" /></MainLayout>;
        case '/meal-logging': return <MainLayout showAnnouncement={false}><OrganicLanding content={organicPages.logging} page="logging" /></MainLayout>;
        case '/nutrition-fitness-recovery': return <MainLayout showAnnouncement={false}><OrganicLanding content={organicPages.routine} page="routine" /></MainLayout>;
        case '/how-nurvo-works': return <MainLayout showAnnouncement={false}><OrganicLanding content={organicPages.method} page="method" /></MainLayout>;
        case '/privacy': return deferredPage(<Privacy />);
        case '/terms': return deferredPage(<Terms />);
        case '/cookies': return deferredPage(<Cookies />);
        default: return deferredPage(<NotFound />);
    }
};

function App() {
    useEffect(() => {
        initGA();
        trackPageView(window.location.pathname);
    }, []);

    return (
        <ThemeProvider defaultTheme="dark" storageKey="nurvo-theme">
            {routeContent()}
            <CookieConsent />
        </ThemeProvider>
    );
}

export default App;
